export const formInformation = (data) => {
  if (!data) {
    return {
      patientID:'',
      idConfer:'',
      idType:'',
      formID:'',
      patientFormID:''
    };
  }
  const patientID = Number(data.split('-')[0].toString());
  const idConfer = Number(data.split('-')[1].toString());
  const idType = Number(data.split('-')[2].toString());
  const formID = Number(data.split('-')[3].toString());
  const patientFormID = data.split('-')[4]
    ? Number(data.split('-')[4].toString())
    : null;

  return {
    patientID,
    idConfer,
    idType,
    formID,
    patientFormID,
  };
};
